module.exports = __webpack_public_path__ + "img/progress.2dac3a40.png";